


















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Button from '@/components/Button.vue';

@Component({
  components:{Button},
})
export default class Labels extends Vue {
  
  get tags(){
      return this.$store.state.tagList;
    }
  created() {
   this.$store.commit('fetchTags'); 
  }

  createTag() {
    const name = window.prompt('请输出标签名');
    if (name) {
      this.$store.commit('createTag',name);
    }
  }
}
